import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";

import FormData from "form-data";

import axios from "axios";

function Document() {
  const [cardData, setCardData] = useState("");
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true)


  useEffect(() => {
    console.log("ththth", cardData);
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData("");
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://tmn2k3m8o1.execute-api.ap-south-1.amazonaws.com/default/Document_Recognition",
      headers: {
        "x-api-key": "aq69Mrmj3i7glakeiDtXq2n0QBPE5Jg2ob3Q0Fv6",
        authorizationToken: "AxK9aeyVZ1D6V4sx",
        
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true)
      })
      .catch(function (error) {
        setLoading(true)
        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div class="container containerBoreder " >
        <h2 class="pageTitle">Financial Proof</h2>
        <div class="row">
            <div class="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div class="col-4">
              <button class="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
        <br />


       
{/* //Form 16// */}

          {cardData.Document_Type === 2? (
          <table class="table">
            <tbody>
              <tr>
                <th width="25%">Document Type </th>
                <td> {cardData.Document_Type}</td>
              </tr>
              <tr>
                <th>Document Name</th>
                <td> {cardData.Document_Name}</td>
              </tr>
              <tr>
                <th>Status</th>
                <td> {cardData.Status}</td>
              </tr>
              <tr>
                <th>Pan Number</th>
                <td> {cardData.pan_number}</td>
              </tr>
              <tr>
                <th>Name of Employee</th>
                <td> {cardData.name_of_employee}</td>
              </tr>
              <tr>
                <th>Period From</th>
                <td> {cardData.period_from}</td>
              </tr>
              <tr>
                <th>Period To</th>
                <td> {cardData.period_to}</td>
              </tr>
              <tr>
                <th>Assesment Year</th>
                <td> {cardData.assesment_year}</td>
              </tr>
              <tr>
                <th>Employee Address</th>
                <td>{cardData.employee_address}</td>
              </tr>
              <tr>
              <th>Page Count</th>
                <td>{cardData.Page_Count}</td>
              </tr>
            </tbody>
          </table>
        ) : 
          ""}

          
        {/* Bank Statement */}


        {cardData.Document_Type === 1? (
          <table class="table">
            <tbody>
              <tr>
                <th width="25%">Document Type</th>
                <td> {cardData.Document_Type}</td>
              </tr>
              <tr>
                <th>Document Name</th>
                <td> {cardData.Document_Name}</td>
              </tr>
              
              <tr>
                <th>Status</th>
                <td> {cardData.Status}</td>
              </tr>
              <tr>
                <th>Bank Name</th>
                <td> {cardData.bank_name}</td>
              </tr>
              <tr>
                <th>From Date</th>
                <td> {cardData.from_date}</td>
              </tr>
              <tr>
                <th>TO Date</th>
                <td> {cardData.to_date}</td>
              </tr>
              <tr>
                <th>Account Number</th>
                <td> {cardData.account_no}</td>
              </tr>
              <tr>
                <th>Holder Name</th>
                <td>{cardData.holder_name}</td>
              </tr>
              <tr>
                <th>IFSC Code</th>
                <td>{cardData.ifsc_code}</td>
              </tr>
              <tr>
                <th>Page Count</th>
                <td> {cardData.Page_Count}</td>
              </tr>
            </tbody>
          </table> 
          ) : 
          ""}


          {/* ITR */}

          {cardData.Document_Type === 3? (
          <table class="table">
            <tbody>
              <tr>
                <th width="25%">Document Type</th>
                <td> {cardData.Document_Type}</td>
              </tr>
              <tr>
                <th>Document Name</th>
                <td> {cardData.Document_Name}</td>
              </tr>
              <tr>
              <th>Status</th>
              <td>{cardData.Status}</td>
            </tr>
              <tr>
                <th>Pan Number</th>
                <td> {cardData.Pan_Number}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td> {cardData.Address}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td> {cardData.Name}</td>
              </tr>
              <tr>
                <th>Assessment Year</th>
                <td> {cardData.Assessment_year}</td>
              </tr>
              <tr>
                <th>Acknowledgement Number</th>
                <td> {cardData.Acknowledgement_Number}</td>
              </tr>
              <tr>
                <th>Total Income</th>
                <td>{cardData.Total_Income}</td>
              </tr>
              {/* <tr>
                <th>QR Code Number</th>
                <td>{cardData.QR_Code_Number}</td>
              </tr> */}
              <tr>
                <th>Page Count</th>
                <td>{cardData.Page_Count}</td>
              </tr>
            </tbody>
          </table>
        ) : 
          ""}

          {/* DP Statement */}

       {cardData.Document_Type === 4? (
          <table class="table">
          <tbody>
            <tr>
              <th width="25%">Document Type </th>
              <td>{cardData.Document_Type}</td>
            </tr>
            <tr>
              <th width="25%">Document Name </th>
              <td>{cardData.Document_Name}</td>
            </tr>
            <tr>
              <th>Status</th>
              <td>{cardData.Status}</td>
            </tr>
            <tr>
              <th>DP ID</th>
              <td>{cardData.DP_ID}</td>
            </tr>
            <tr>
              <th>Client ID</th>
              <td>{cardData.Client_ID}</td>
            </tr>
            <tr>
              <th>Broker Name</th>
              <td>{cardData.Broker_name}</td>
            </tr>
            <tr>
              <th>Name</th>
              <td>{cardData.Name}</td>
            </tr>
            <tr>
              <th>Bill Date TO</th>
              <td>{cardData.Bill_Date_TO} </td>
            </tr>
            <tr>
              <th>DP Status</th>
              <td>{cardData.Dp_status} </td>
            </tr>
            <tr>
              <th>Type</th>
              <td>{cardData.Type} </td>
            </tr>
            <tr>
              <th>Subtype</th>
              <td>{cardData.Subtype}</td>
            </tr>
            <tr>
              <th>BSDA</th>
              <td>{cardData.BSDA}</td>
            </tr>
            <tr>
              <th>Category</th>
              <td>{cardData.Category}</td>
            </tr>
           <tr>
              <th>Address</th>
              <td>{cardData.Address}</td>
            </tr>
            <tr>
              <th> Page Count</th>
              <td>{cardData.Page_Count}</td>
            </tr>
         

          </tbody>
        </table>
        ) : 
          ""}
          {/* //net Worth// */}
            {cardData.Document_Type === 5? (
          <table class="table">
          <tbody>
            <tr>
              <th width="25%">Document Type </th>
              <td>{cardData.Document_Type}</td>
            </tr>
            <tr>
              <th width="25%">Document Name </th>
              <td>{cardData.Document_Name}</td>
            </tr>
            <tr>
              <th>Status</th>
              <td>{cardData.Status}</td>
            </tr>
            <tr>
              <th>Applicant Name</th>
              <td>{cardData.Applicant_Name}</td>
            </tr>
            <tr>
              <th>Month Year</th>
              <td>{cardData.Month_Year}</td>
            </tr>
            <tr>
              <th>Page Count</th>
              <td>{cardData.Page_Count}</td>
            </tr>
           
            

          </tbody>
        </table>
        ) : 
          ""}
   {/* Salary */}
{cardData.Document_Type === 6? (
          <table class="table">
          <tbody>
            <tr>
              <th width="25%">Document Type </th>
              <td>{cardData.Document_Type}</td>
            </tr>
            <tr>
              <th width="25%">Document Name </th>
              <td>{cardData.Document_Name}</td>
            </tr>
            <tr>
              <th>Status</th>
              <td>{cardData.Status}</td>
            </tr>
            <tr>
              <th>Applicant Name</th>
              <td>{cardData.Applicant_Name}</td>
            </tr>
            <tr>
              <th>Month Year</th>
              <td>{cardData.Month_Year}</td>
            </tr>
            <tr>
              <th>Account Number</th>
              <td>{cardData.Account_Number}</td>
            </tr>
            <tr>
              <th>Page Count</th>
              <td>{cardData.Page_Count}</td>
            </tr>
           
            
          

          </tbody>
        </table>
        ) : 
          ""}

          {/* Annual Income */}
            {cardData.Document_Type === 7? (
          <table class="table">
          <tbody>
            <tr>
              <th width="25%">Document Type </th>
              <td>{cardData.Document_Type}</td>
            </tr>
            <tr>
              <th width="25%">Document Name </th>
              <td>{cardData.Document_Name}</td>
            </tr>
            <tr>
              <th>Status</th>
              <td>{cardData.Status}</td>
            </tr>
            <tr>
              <th>Applicant Name</th>
              <td>{cardData.Applicant_Name}</td>
            </tr>
            <tr>
              <th>Gender</th>
              <td>{cardData.Gender}</td>
            </tr>
            <tr>
              <th>Month Year</th>
              <td>{cardData.Month_Year}</td>
            </tr>
            <tr>
              <th>Page Count</th>
              <td>{cardData.Page_Count}</td>
            </tr>
         
            

          </tbody>
        </table>
        ) : 
          ""}
           {cardData.Document_Type === 0? (
          <table class="table">
          <tbody>
            <tr>
              <th width="25%">Document Type </th>
              <td>{cardData.Document_Type}</td>
            </tr>
          </tbody>
        </table>
        ) : 
          ""}
      </div>
    </div>
  );
}

export default Document;
